export const notifierMessage = {
  requestType: {
    error: 'Failed to complete your request for Request Type, please try again later.',
  },
  billingEngagementStatus: {
    error: 'Failed to complete your request for Billing Engagement Status, please try again later.',
  },
};
